import { INVALID_REQUIRED_MESSAGE } from '../constants/service/invalidMsg/commonInvalidMsg';

/**
 *  FORM 데이터의 필수 조건 규칙
 */
export const formRequiredRules = (required, message, whitespace = true, type) => {
  const rules = { required, message };

  if (!message) {
    rules.message = INVALID_REQUIRED_MESSAGE;
  }
  if (whitespace) {
    rules.whitespace = true;
  }

  if (type) {
    rules.type = type;
  }

  return rules;
};

/**
 * SearchAddress 컴포넌트의 validation rule
 */
export const searchAddressRule = (errorMessage = '필수 값입니다.') => {
  return {
    validator: (rule, value, callback) => {
      if (!value || !value.city || !value.postCode || !value.line1) {
        callback(errorMessage);
      }

      callback();
    },
  };
};
